module.exports = __webpack_public_path__ + "img/categoriespost.239b944b.jpg";